import { createBrowserHistory } from 'history';

const history = createBrowserHistory();
export default history;



// WEBPACK FOOTER //
// ./src/helpers/history.ts